import { useState } from 'react';
import { FormControl, FormLabel, Stack, Box, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { useField } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { defaultChakraSelectStyle, chakraSelectDarkMode } from '@/constants';

const SelectField = ({
    name,
    label,
    description,
    options,
    required,
    darkMode,
    walkthroughId,
    tooltip,
    isDisabled,
    placeholder = '— Select —',
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const [field, , helpers] = useField(name);
    const chakraSelectDark = chakraSelectDarkMode(darkMode);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        {label}{' '}
                        {required && (
                            <span style={{ color: '#e53e3e' }}>*</span>
                        )}
                    </FormLabel>
                    {description && (
                        <Box sx={descriptionStyling} maxWidth={250}>
                            {description}
                        </Box>
                    )}
                </Box>
                <Box flex="1" paddingTop="15px">
                    <VStack alignItems="normal">
                        <Select
                            value={
                                options.find((o) => o.value === field.value) ||
                                null
                            }
                            options={options}
                            placeholder={placeholder}
                            isDisabled={isDisabled}
                            onChange={(opt) =>
                                helpers.setValue(opt ? opt.value : '')
                            }
                            chakraStyles={{
                                ...defaultChakraSelectStyle,
                                ...(darkMode ? chakraSelectDark : {}),
                            }}
                            data-walkthroughid={walkthroughId}
                        />
                    </VStack>
                </Box>
                {isHovered && tooltip && (
                    <FieldToolTip
                        label={tooltip}
                        ariaLabel={`${name}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SelectField;
